import { withTranslation } from "react-i18next";
import WithRouter from "../../../components/Common/WithRouter";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { get, includes, isEmpty, orderBy, reverse } from "lodash";
import { request } from "../../../utils/Request";
import { utcDateToLocalDate } from "../../../utils/Helper";
import { useSearchParams } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";
import Location from "../../../components/Common/Display/Location";
import AlpOutboundLoadStatus from "./partials/AlpOutboundLoadStatus";
import VinWithType from "../../../components/Common/Display/VinWithType";
import { navigateBackToList } from "../../../utils/listNavigation";
import OrderLabel from "../../../components/Common/Display/OrderLabel";

const AlpOutboundLoadDetail = (props: any) => {
    const { t, toastify, params } = props;
    const [entity, setEntity] = useState<any>(null);
    const [searchParams] = useSearchParams();
    const [activeIndex, setActiveIndex] = useState(0);

    const getCurrentCmrDocuments = (cmrDocuments: any): any[] => {
        if ( Array.isArray(cmrDocuments) ) {
            return cmrDocuments;
        }

        return Array.isArray(cmrDocuments?.current) ? cmrDocuments.current : [];
    };

    const getPreviousCmrDocuments = (cmrDocuments: any): any[] => {
        return Array.isArray(cmrDocuments?.previous) ? cmrDocuments.previous : [];
    };

    const getCmrDocumentRows = (cmrDocuments: any): any[] => {
        const current = orderBy(getCurrentCmrDocuments(cmrDocuments), ['created_at'], ['desc'])
            .map((cmr: any) => ({ cmr, label: 'current cmr' }));
        const previous = orderBy(getPreviousCmrDocuments(cmrDocuments), ['deleted_at', 'created_at'], ['desc', 'desc'])
            .map((cmr: any) => ({ cmr, label: 'previous cmr' }));

        return [...current, ...previous];
    };

    const getDetail = async (id: string) => {
        try {
            const response = await request({
                url: `/suppliers/alp/outbound/loads/${ id }`
            });

            const { data } = response.data;
            setEntity(data);
        } catch (error) {
            toastify(t("server error"), "error");
        }
    };

    const onClose = () => {
        // make sure back_to and back_with are not blank and redirect with all parameters
        if ( !isEmpty(searchParams.get('back_to')) ) {
            navigateBackToList(props.router.navigate, `${ searchParams.get('back_to') }`);
            return;
        }

        props.onClose();
    };

    useEffect(() => {
        if ( includes(['detail'], get(params, ['operation'])) ) {
            getDetail(params.operationId);
        }
    }, [params]);

    return (
        <div className={ "p-4 bg-white" }>
            {
                entity &&
              <>
                  <Row>
                      {
                          entity &&
                        <div>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('load number') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end text-uppercase">
                                        { entity.load_number }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('supplier compound') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end text-uppercase">
                                        <div>{ entity.supplier_compound }</div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('dealer') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end text-uppercase">
                                        <div>{ entity.dealer_name }</div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('status') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end text-uppercase">
                                        <AlpOutboundLoadStatus
                                          status={ entity.status } />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('created at') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end text-uppercase">
                                        { utcDateToLocalDate(entity.created_at) }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('last synced at') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end text-uppercase">
                                        { entity.last_synced_at ? utcDateToLocalDate(entity.last_synced_at) : '-' }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span
                                              className="text-capitalize">{ t('transport vehicle') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { entity.truck_plate_number } { entity.trailer_plate_number && ` | ${ entity.trailer_plate_number }` }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('driver') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { entity.driver_name }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                                <span
                                                  className="text-capitalize">{ t('gate out confirmed') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { utcDateToLocalDate(entity.gate_out_confirmed_at) }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                                <span
                                                  className="text-capitalize">{ t('estimated loading time') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { entity.estimated_loading_time && utcDateToLocalDate(entity.estimated_loading_time) }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span
                                          className="text-capitalize">{ t('actual loading') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { entity.actual_loading_time && utcDateToLocalDate(entity.actual_loading_time) }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span
                                          className="text-capitalize">{ t('estimated unloading') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { entity.estimated_unloading_time && utcDateToLocalDate(entity.estimated_unloading_time) }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                                <span
                                                  className="text-capitalize">{ t('actual unloading') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { entity.actual_unloading_time && utcDateToLocalDate(entity.actual_unloading_time) }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('price') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { entity.a_s_price }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('efl price') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { get(entity, ['emil_frey_price']) }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span
                                          className="text-capitalize">{ t('is billable?') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { !isEmpty(entity.invoiceable_at) ? t("yes") : t("no") }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('is billed?') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { !isEmpty(entity.invoiced_at) ? t("yes") : t("no") }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('cmr') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { entity.cmr }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="6" sm="12">
                                    <h6>
                                        <span className="text-capitalize">{ t('travel order') }</span>
                                    </h6>
                                </Col>
                                <Col md="6" lg="6" sm="12">
                                    <div className="text-end">
                                        { get(entity, ['travel_order', 'travel_order_number']) }
                                    </div>
                                </Col>
                            </Row>
                            {
                                !isEmpty(get(entity, ['start_log', 'latitude'])) &&
                              <>
                                  <div className={ "row" }>
                                      <Col sm={ 12 } md={ 4 }>
                                          <h6>{ t('start position') }: </h6>
                                      </Col>
                                      <Col sm={ 12 } md={ 8 } className={ "text-end" }>
                                          <a
                                            href={ "https://www.google.com/maps/place/" + ( get(entity, ['start_log', 'latitude']) ) + ',' + get(entity, ['start_log', 'longitude']) }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                              {t('show on map')}
                                          </a>
                                      </Col>
                                  </div>
                                  <div className={ "row" }>
                                      <Col sm={ 12 } md={ 4 }>
                                          <h6>{ t('end position') }: </h6>
                                      </Col>
                                      <Col sm={ 12 } md={ 8 } className={ "text-end" }>
                                          <a
                                            href={ "https://www.google.com/maps/place/" + ( get(entity, ['end_log', 'latitude']) ) + ',' + get(entity, ['end_log', 'longitude']) }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                              {t('show on map')}
                                          </a>
                                      </Col>
                                  </div>
                              </>
                            }
                            <Row>
                                <TabView activeIndex={ activeIndex }
                                         onTabChange={ (e) => setActiveIndex(e.index) }>
                                    <TabPanel header={ t('orders') }>
                                        <div className="table-responsive">
                                            <table className={ "fl-table w-full" }>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>{ t('from location') }</th>
                                                        <th>{ t('to location') }</th>
                                                        <th>{ t('vin number') }</th>
                                                        <th>{ t('brand') }</th>
                                                        <th>{ t('status') }</th>
                                                        <th>{ t('price') }</th>
                                                        <th>{ t('efl price') }</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        entity.alp_outbound_load_orders.map((order: any, orderIndex: number) => {
                                                            return (
                                                                <tr key={ orderIndex }>
                                                                    <td>{ orderIndex + 1 }</td>
                                                                    <td>
                                                                      <Location
                                                                          item={ entity.from_location }
                                                                          titled={ 0 } />
                                                                    </td>
                                                                    <td>
                                                                      <Location
                                                                          item={ entity.to_location }
                                                                          titled={ 0 } />
                                                                    </td>
                                                                    <td>
                                                                        <VinWithType
                                                                            vinNumber={ get(order, ['order', 'vin_number']) } />
                                                                        <div>{ get(order, ['order', 'order_cd']) }</div>
                                                                    </td>
                                                                    <td>
                                                                    <span
                                                                        className={ "text-capitalize" }>
                                                                          { ( get(order, ['order', 'brand', 'title']) ) }
                                                                        <span
                                                                            className={ "text-capitalize d-block" }>
                                                                               { get(order, ['order', 'brand_model', 'title']) }
                                                                            - { get(order, ['order', 'brand_model', 'version_code']) }
                                                                          </span>
                                                                      </span>
                                                                    </td>
                                                                    <td>
                                                                        <span>{ `${ order.status }`.toUpperCase() }</span>
                                                                        <OrderLabel
                                                                            labels={ get(order, ['order', 'order_labels']) }
                                                                            className="mt-1"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <span>{ order.input_price && order.input_price }</span>
                                                                    </td>
                                                                    <td>
                                                                        <span>{ order.emil_frey_price }</span>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </TabPanel>
                                    <TabPanel header={ t('status histories') }>
                                        <div className="table-responsive">
                                            <table className={ "fl-table w-full" }>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>{ t('author') }</th>
                                                        <th>{ t('status') }</th>
                                                        <th>{ t('comments') }</th>
                                                        <th>{ t('created at') }</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        entity.status_histories && orderBy(entity.status_histories, ['created_at'], ['desc']).map((history: any, historyIndex: number) => {
                                                            return (
                                                                <tr key={ historyIndex }>
                                                                    <td>{ historyIndex + 1 }</td>
                                                                    <td>
                                                                        { get(history, ['author', 'name']) }
                                                                    </td>
                                                                    <td>
                                                                                        <span
                                                                                            className={ "text-uppercase" }>{ history.status }</span>
                                                                    </td>
                                                                    <td>
                                                                        { history.comments }
                                                                        <div>{ history.system_note }</div>
                                                                    </td>
                                                                    <td>
                                                                        { utcDateToLocalDate(history.created_at) }
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </TabPanel>
                                    { false && <TabPanel header={ t('status history from alp') }>
                                        <div className="table-responsive">
                                            <table className={ "fl-table w-full" }>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>{ t('author') }</th>
                                                        <th>{ t('status') }</th>
                                                        <th>{ t('comments') }</th>
                                                        <th>{ t('created at') }</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        entity.alp_status_histories && orderBy(entity.alp_status_histories, ['created_at'], ['desc']).map((history: any, historyIndex: number) => {
                                                            return (
                                                                <tr key={ historyIndex }>
                                                                    <td>{ historyIndex + 1 }</td>
                                                                    <td>{ get(history, ['author']) }</td>
                                                                    <td>
                                                                                <span
                                                                                    className={ "text-uppercase" }>{ history.status }</span>
                                                                    </td>
                                                                    <td>{ history.comments }</td>
                                                                    <td>{ utcDateToLocalDate(history.created_at) }</td>
                                                                </tr>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </TabPanel> }
                                    <TabPanel header={ t('documents') }>
                                        <div className="table-responsive">
                                            <table className={ "fl-table w-full" }>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>{ t('title') }</th>
                                                        <th>{ t('type') }</th>
                                                        <th>{ t('created at') }</th>
                                                        <th>{ t('action') }</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        entity.alp_documents && orderBy(entity.alp_documents, ['created_at'], ['desc']).map((history: any, historyIndex: number) => {
                                                            return (
                                                                <tr key={ historyIndex }>
                                                                    <td>{ historyIndex + 1 }</td>
                                                                    <td>{ get(history, ['title']) }</td>
                                                                    <td>{ get(history, ['additional_info_one']) }</td>
                                                                    <td>{ utcDateToLocalDate(history.created_at) }</td>
                                                                    <td>
                                                                        <a href={ history.alp_document_url } target="_blank">
                                                                            <i className="fas fa-download"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    }

                                                    { getCmrDocumentRows(entity.cmr_documents).map((item: any, i: number) => {
                                                        const cmr = item.cmr;

                                                        return (
                                                        <tr key={ `cmr-${ item.label }-${ cmr?.id ?? i }` }>
                                                            <td>{ (entity.alp_documents || []).length + i + 1 }</td>
                                                            <td>
                                                                <div>{ cmr?.cmr_number ?? '-' }</div>
                                                                <div className="text-muted small">{ t(item.label) }</div>
                                                            </td>
                                                            <td>{ t('cmr') }</td>
                                                            <td>{ cmr?.created_at ? utcDateToLocalDate(cmr.created_at) : '-' }</td>
                                                            <td>
                                                                { cmr?.document?.id && (
                                                                    <a
                                                                        href={ `${ process.env.REACT_APP_DOCUMENT_URL }/${ cmr.document.id }` }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <i className="fas fa-download"></i>
                                                                    </a>
                                                                ) }
                                                            </td>
                                                        </tr>
                                                        );
                                                    }) }
                                                </tbody>
                                            </table>
                                        </div>
                                    </TabPanel>
                                </TabView>
                            </Row>
                        </div>
                      }
                  </Row>
              </>
            }
        </div>

    );
};

AlpOutboundLoadDetail.propTypes =
{
    // t: PropTypes.any,
};

export default withTranslation()(WithRouter(AlpOutboundLoadDetail));
